// extracted by mini-css-extract-plugin
export default {"email_logo":"Resetpasswordemail_email_logo__ovmjd","h3":"Resetpasswordemail_h3__4njOf","p":"Resetpasswordemail_p__3rzC+"};